import InstitutionalBlurbBody from './InstitutionalBlurbBody';
import type { InstitutionalBlurbData } from './InstitutionalBlurbBody';

const InstitutionalBlurbView = ({ data }: { data: InstitutionalBlurbData }) => (
  <InstitutionalBlurbBody data={data} />
);

export default InstitutionalBlurbView;
